import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import BottomNav from '../components/BottomNav';

export default function About() {
  const [data, setData] = useState({
    yandexMapLink: '',
    addresses: [],
    schedule: []
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/about')
      .then(res => {
        if (!res.ok) throw new Error('Не удалось загрузить данные');
        return res.json();
      })
      .then(fetchedData => {
        setData(fetchedData);
        setLoading(false);
      })
      .catch(err => {
        console.error('Ошибка загрузки данных:', err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#1b1b1b] flex items-center justify-center text-[#dedede]">
        <p className="text-xl">Загрузка...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#1b1b1b] text-[#dedede] font-['Inter',sans-serif] antialiased overflow-x-hidden">
      <Header />

      <section className="py-24 bg-[#1b1b1b]">
        <div className="max-w-screen-2xl mx-auto px-8">
          <div className="mb-20 text-center">
            <span className="text-[20px] font-black uppercase tracking-[0.5em] text-primary">Чтобы начать</span>
            <h1 className="text-3xl md:text-6xl font-black uppercase tracking-tighter mt-2">
              придите в любой филиал для регистрации.
            </h1>
          </div>

          {/* Карта */}
          {data.yandexMapLink && (
            <div className="glass-card rounded-[28px] p-8 md:p-12 mb-12 shadow-[0_0_30px_rgba(184,151,90,0.1)]">
              <div style={{ height: '500px' }} className="rounded-2xl overflow-hidden">
                <iframe
                  src={data.yandexMapLink}
                  width="100%"
                  height="100%"
                  frameBorder="0"
                  title="Карта филиалов автошколы Драйв"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          )}

          {/* Филиалы + График работы (на месте бывших контактов) */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 gap-8 md:items-start">
            {/* Филиалы */}
            {data.addresses?.length > 0 ? (
              data.addresses.map((filial) => (
                <div key={filial.id} className="glass-card rounded-[28px] p-8 md:p-10 text-center">
                  <h3 className="text-2xl font-black uppercase tracking-tight mb-4 text-gold">
                    {filial.name || 'Наш филиал'}
                  </h3>
                  <p className="text-[#dedede] leading-relaxed">
                    {filial.address || 'Адрес не указан'}
                  </p>
                  {filial.phone && (
                    <p className="mt-4 text-primary font-bold">
                      Тел: {filial.phone}
                    </p>
                  )}
                </div>
              ))
            ) : (
              <div className="glass-card rounded-[28px] p-8 md:p-10 text-center">
                <h3 className="text-2xl font-black uppercase tracking-tight mb-4 text-gold">
                  Наш филиал
                </h3>
                <p className="text-[#dedede] leading-relaxed">
                  Луганск, ул. Советская 77, ТЦ. ГУМ, 2 этаж, к.133
                </p>
                <p className="mt-4 text-primary font-bold">
                  Тел: +7 (959) 271-62-26
                </p>
              </div>
            )}

            {/* График работы — вместо контактов */}
            <div className="glass-card rounded-[28px] p-8 md:p-10 text-center">
              <h3 className="text-2xl font-black uppercase tracking-tight mb-6 text-gold">
                График работы
              </h3>
              <div className="space-y-4 text-[#dedede] leading-relaxed">
                {data.schedule?.length > 0 ? (
                  data.schedule.map((item, index) => (
                    <p key={item.id || index} className="text-base md:text-lg">
                      {item.hours}
                    </p>
                  ))
                ) : (
                  <p className="text-slate-400">
                    Работаем ежедневно с 9:00 до 21:00
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <BottomNav />
    </div>
  );
}